import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="7" y1="4" x2="1" y2="4" stroke="#B5B8BA" stroke-width="2" stroke-linecap="round" />
      <line x1="4" y1="1" x2="4" y2="7" stroke="#B5B8BA" stroke-width="2" stroke-linecap="round" />
    </svg>
  );
};

export default Svg;
